import { ActiveCallsRegisterListItem } from '../models/active-calls-register-results.model';

export function buildHangupConfirmationMessage(activeCall: ActiveCallsRegisterListItem): string {
   const messageLines = ['Are you sure you want to hang up this call?', ''];
   const accountName = activeCall.accountName?.trim();

   if (accountName) {
      messageLines.push(`Account: ${accountName}`);
   }

   messageLines.push(`From: ${activeCall.callSource}`, `To: ${activeCall.callDestination}`);
   return messageLines.join('\n');
}
